var _path, _circle, _circle2, _path2, _circle3, _circle4, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSmartwatch = function SvgSmartwatch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M52 21.53V12a3 3 0 0 0-3-3H31a3 3 0 0 0-3 3v9.53a7 7 0 0 0-6.5 7v23a7 7 0 0 0 6.5 7V68a3 3 0 0 0 3 3h18a3 3 0 0 0 3-3v-9.53a7 7 0 0 0 6.5-7v-23a7 7 0 0 0-6.5-6.94M30 12a1 1 0 0 1 1-1h7.28a2 2 0 0 0 3.44 0H49a1 1 0 0 1 1 1v9.5H30Zm20 56a1 1 0 0 1-1 1h-7.28a2 2 0 0 0-3.44 0H31a1 1 0 0 1-1-1v-9.5h20Zm6.5-16.5a5 5 0 0 1-5 5h-23a5 5 0 0 1-5-5v-23a5 5 0 0 1 5-5h23a5 5 0 0 1 5 5Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 63.75,
    r: 2,
    fill: "currentColor"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 16.25,
    r: 2,
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M33.5 39v-3a1 1 0 0 0-2 0v3h-1v-3a1 1 0 0 0-2 0v4a1 1 0 0 0 1 1h2v3a1 1 0 0 0 2 0v-3a1 1 0 0 0 0-2"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 38,
    r: 1,
    fill: "currentColor"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 42,
    r: 1,
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M41.5 35a3 3 0 0 0-3 3v4a3 3 0 0 0 6 0v-4a3 3 0 0 0-3-3m1 7a1 1 0 0 1-2 0v-4a1 1 0 0 1 2 0ZM48.5 35a3 3 0 0 0-3 3v4a3 3 0 0 0 6 0v-4a3 3 0 0 0-3-3m1 7a1 1 0 0 1-2 0v-4a1 1 0 0 1 2 0Z"
  })));
};
export default SvgSmartwatch;